import React, { useState } from 'react';
import Breadcrumb from '../../../common/breadcrumb';
import LoadingIndicator from '../../../common/loadingIndicator';
import OperationalDashboardFilters from './operationalDashboardFilters';
import OperationalDashboardBody from './operationDashboardBody';

/**
 * Operational Dashboard +
 * 13-month monthly view of operational metrics.
 */
const OperationalDashboardPlus = () => {
    const [dashboardData, setDashboardData] = useState(null);
    const [reportFilters, setReportFilters] = useState({
        isLoading: false,
        isSubmitted: false,
    });

    const reportFilterProps = {
        setReportFilters,
        setDashboardData,
    };

    const reportBodyProps = {
        dashboardData,
    };

    return (
        <>
            <Breadcrumb title="Operational Dashboard +" parent="Toolbox"/>
            <LoadingIndicator isLoading={reportFilters.isLoading}/>
            <OperationalDashboardFilters {...reportFilterProps} />
            <OperationalDashboardBody {...reportBodyProps} />
        </>
    );
}

export default OperationalDashboardPlus;
